import { defineComponent, h } from "vue";
import { rehype } from "rehype";
function extractRootHtmlElement(html) {
  const root = {
    tagName: "",
    properties: {},
    innerHTML: ""
  };
  const result = rehype().data("settings", { fragment: true }).use(() => {
    return (tree) => {
      if (!("children" in tree && Array.isArray(tree.children))) return;
      const first = tree.children[0];
      if (first.type === "element") {
        root.tagName = first.tagName;
        Object.assign(root.properties, first.properties);
        tree.children = first.children;
      }
    };
  }).processSync(html).toString();
  root.properties.innerHTML = result;
  return root;
}
function toVueComponent(render, propTemplate) {
  return defineComponent({
    props: Object.keys(propTemplate),
    setup(props) {
      return () => {
        const root = extractRootHtmlElement(render(props));
        return h(root.tagName, root.properties);
      };
    }
  });
}
function svgToVueComponent(svg) {
  return toVueComponent(() => svg, {});
}
export {
  extractRootHtmlElement,
  svgToVueComponent,
  toVueComponent
};
//# sourceMappingURL=component-from-string.js.map
